var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { updateGenericEvent } from '../services/CalendarService';
export function useUpdateGenericEvent() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (_a) => __awaiter(this, [_a], void 0, function* ({ eventId, data }) {
            const response = yield updateGenericEvent(eventId, data);
            if (response.error) {
                throw new Error(response.error.message);
            }
            return response.data;
        }),
        onMutate: (_a) => __awaiter(this, [_a], void 0, function* ({ eventId, data }) {
            yield queryClient.cancelQueries({ queryKey: ['calendar', 'genericEvents'] });
            const previousGenericEventQueries = queryClient.getQueriesData({
                queryKey: ['calendar', 'genericEvents']
            });
            queryClient.setQueriesData({ queryKey: ['calendar', 'genericEvents'] }, (old) => {
                if (!old)
                    return old;
                return Object.assign(Object.assign({}, old), { genericEvents: old.genericEvents.map((e) => e.id === eventId
                        ? Object.assign(Object.assign(Object.assign({}, e), { start: data.start, end: data.end }), (data.allDay !== undefined ? { allDay: data.allDay } : {})) : e) });
            });
            return { previousGenericEventQueries };
        }),
        onError: (_err, _vars, context) => {
            var _a;
            (_a = context === null || context === void 0 ? void 0 : context.previousGenericEventQueries) === null || _a === void 0 ? void 0 : _a.forEach(([queryKey, oldData]) => {
                queryClient.setQueryData(queryKey, oldData);
            });
            toast.error('Failed to update event. Change has been reverted.');
        },
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey: ['calendar', 'genericEvents'] });
        }
    });
}
